import { Company } from 'generated/apolloComponents'
import twitterIcon from 'public/social-icons/twitter.svg'
import facebookIcon from 'public/social-icons/facebook.svg'
import instagramIcon from 'public/social-icons/instagram.svg'
import linkedinIcon from 'public/social-icons/linkedin.svg'
import websiteIcon from 'public/social-icons/website.svg'
import githubIcon from 'public/social-icons/github.svg'
import youtubeIcon from 'public/social-icons/youtube.svg'

interface IProps {
  company: Company
  theme: string
  className?: string
}

const CompanySocial = ({ company, theme, className = '' }: IProps) => (
  <div className={className}>
    {company.facebook && (
      <a
        href={company.facebook}
        title='Facebook'
        rel='nofollow noopener noreferrer'
        target='_blank'
      >
        <img
          src={facebookIcon.src}
          width={24}
          height={24}
          className='mr-14'
          alt='Facebook'
        />
      </a>
    )}
    {company.linkedin && (
      <a
        href={company.linkedin}
        title='Linkedin'
        rel='nofollow noopener noreferrer'
        target='_blank'
      >
        <img
          src={linkedinIcon.src}
          width={24}
          height={24}
          className='mr-14'
          alt='LinkedIn'
        />
      </a>
    )}
    {company.twitter && (
      <a
        href={company.twitter}
        title='X'
        rel='nofollow noopener noreferrer'
        target='_blank'
      >
        <img
          src={twitterIcon.src}
          width={24}
          height={24}
          className='mr-14'
          alt='X'
        />
      </a>
    )}
    {company.instagram && (
      <a
        href={company.instagram}
        title='Instagram'
        rel='nofollow noopener noreferrer'
        target='_blank'
      >
        <img
          src={instagramIcon.src}
          width={24}
          height={24}
          className='mr-14'
          alt='Instagram'
        />
      </a>
    )}
    {company.github && (
      <a
        href={company.github}
        title='GitHub'
        rel='nofollow noopener noreferrer'
        target='_blank'
      >
        <img
          src={githubIcon.src}
          width={24}
          height={24}
          className='mr-14'
          alt='GitHub'
        />
      </a>
    )}
    {company.youtube && (
      <a
        href={company.youtube}
        title='YouTube'
        rel='nofollow noopener noreferrer'
        target='_blank'
      >
        <img
          src={youtubeIcon.src}
          width={24}
          height={24}
          className='mr-14'
          alt='YouTube'
        />
      </a>
    )}
    {company.website && company.currentLayout !== 'basic' && (
      <a
        href={company.website}
        title={company.website}
        rel='nofollow noopener noreferrer'
        target='_blank'
      >
        <img
          src={websiteIcon.src}
          width={24}
          height={24}
          alt={company.website}
        />
      </a>
    )}
  </div>
)

export default CompanySocial
